import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useForm, ValidationError } from "@formspree/react";

// Styled components
const FormContainer = styled.div`
  max-width: 600px;
  margin: 40px auto;
  padding: 20px;
  background-color: var(--hhb-white);
  border-radius: 8px;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  font-size: var(--font-size-body);
  font-weight: 500;
  color: var(--text-color);
  margin-bottom: 8px;
  display: block;
`;

const Input = styled.input`
  padding: 12px;
  font-size: var(--font-size-body);
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: var(--primary-color);
    outline: none;
  }
`;

const Textarea = styled.textarea`
  padding: 12px;
  font-size: var(--font-size-body);
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
  resize: vertical;
  height: 100px;

  &:focus {
    border-color: var(--primary-color);
    outline: none;
  }
`;

const SubmitButton = styled.button`
  background-color: var(--primary-color);
  color: var(--secondary-color);
  padding: 12px;
  font-size: var(--font-size-body);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 20px;

  &:hover {
    background-color: var(--accent-color);
  }
`;

const ThankYouMessage = styled.div`
  text-align: center;
  padding: 20px;
  background-color: var(--hhb-white);
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const ContactForm = () => {
  const [state, handleSubmit] = useForm("xjkbrvwo");

  if (state.succeeded) {
    return (
      <ThankYouMessage>
        <h2>Thank You!</h2>
        <p>
          Your submission has been received. We will get back to you shortly.
        </p>
        <Link to="/" className="button">
          Return to Home
        </Link>
      </ThankYouMessage>
    );
  }

  return (
    <FormContainer>
      <StyledForm onSubmit={handleSubmit}>
        <FormGroup>
          <Label htmlFor="name">Name:</Label>
          <Input type="text" name="name" id="name" required />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="email">Email:</Label>
          <Input type="email" name="email" id="email" required />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="phone">Phone:</Label>
          <Input type="tel" name="phone" id="phone" required />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="message">Message:</Label>
          <Textarea name="message" id="message" required />
          <ValidationError
            prefix="Message"
            field="message"
            errors={state.errors}
          />
        </FormGroup>

        <SubmitButton type="submit" disabled={state.submitting}>
          Submit
        </SubmitButton>
      </StyledForm>
    </FormContainer>
  );
};

export default ContactForm;
